import React from "react";
import styled from "styled-components";
import { rem } from "polished";
import colors from "../../../utils/colors";

const Wrap = styled.ul`
  li {
    font-size: ${rem("12px")};
    font-weight: 400;
    display: inline-block;
    padding-right: 0.75rem;
    color: ${colors.GRAY_LIGHT};
  }
`;

const TagListCard = props => {
  let { tags } = props;
  if (tags.length === 0) {
    tags.push("");
  }

  return (
    <Wrap>
      {tags.map((tag, index) => {
        return index < 2 ? (
          <li key={index}>{tag !== "" ? "#" + tag : ""}</li>
        ) : index === 2 && tags.length >= 2 ? (
          <li key={index}>...</li>
        ) : null;
      })}
    </Wrap>
  );
};

export default TagListCard;



// WEBPACK FOOTER //
// ./src/modules/common/components/TagListCard.js